import {Component, OnInit} from '@angular/core';
import {LoginService} from '../services/login.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NotificationsService} from 'angular2-notifications';
import {GoogleAnalyticsService} from "../services/google-analytics-service";
import {ModalService} from "../services/modalService/modal.service";
import {GenericModalComponent} from "../generic-modal/generic-modal.component";
import {UnsubscribePaymentModalComponent} from '../custom-modals/unsubscribe-payment-modal.component';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {


  gdprForget = false;
  currentUser: any = {};
  changedUser: any = {};
  resetPwd: FormGroup;
  reset: any = {};
  updateUserForm: FormGroup;
  editProfile = false;
  editResetPassword = false;

  get firstnameHasError() {
    return !this.updateUserForm.controls['firstname'].valid && this.updateUserForm.controls['firstname'].dirty;
  }
  get lastnameHasError() {
    return !this.updateUserForm.controls['lastname'].valid && this.updateUserForm.controls['lastname'].dirty;
  }
  get phoneHasError() {
    return this.updateUserForm.controls['phone'].errors && this.updateUserForm.controls['phone'].errors.pattern;
  }

  constructor(private ga: GoogleAnalyticsService,
              private loginService: LoginService,
              private notifications: NotificationsService,
              private modalService: ModalService,
              private fb: FormBuilder,
              private translate: TranslateService) {
  }

  ngOnInit() {
    const currentUser = this.loginService.getCurrentUser();
    
    this.currentUser.firstName      = currentUser.firstName;
    this.currentUser.lastName       = currentUser.lastName;
    this.currentUser.phone          = currentUser.phone;
    this.currentUser.email          = currentUser.email;
    this.currentUser.paid           = currentUser.paid;
    this.currentUser.paidTo         = currentUser.paidTo;
    this.currentUser.premium        = currentUser.premium;
    this.currentUser.isLoggedIn     = currentUser.isLoggedIn;
    this.currentUser.socialAccount  = currentUser.socialAccount;
    this.currentUser.subscribed     = currentUser.subscribed;
    this.currentUser.singlePayment  = currentUser.singlePayment;
    this.currentUser.paymentInProgress  = currentUser.paymentInProgress;

    this.changedUser.firstName      = currentUser.firstName;
    this.changedUser.lastName       = currentUser.lastName;
    this.changedUser.phone          = currentUser.phone;
    this.changedUser.email          = currentUser.email;
    this.changedUser.paid           = currentUser.paid;
    this.changedUser.paidTo         = currentUser.paidTo;
    this.changedUser.premium        = currentUser.premium;
    this.changedUser.isLoggedIn     = currentUser.isLoggedIn;
    this.changedUser.socialAccount  = currentUser.socialAccount;
    this.changedUser.subscribed     = currentUser.subscribed;
    this.changedUser.singlePayment  = currentUser.singlePayment;
    this.changedUser.paymentInProgress  = currentUser.paymentInProgress;

    this.resetPwd = this.fb.group({
      'oldPassword': ['', Validators.compose([Validators.required])],
      'newPassword': ['', Validators.compose([Validators.required])],
      'confirmPassword': ['', Validators.compose([Validators.required])]
    }, {validator: this.customValidator});

    //const phoneRegex = /^[0-9\- ()+]+$/i; -> initial soultion
    //const phoneRegex = /^[+]?[\s./0-9]*[(]?[0-9]{1,4}[)]?[-\s./0-9]*$/g
    const phoneRegex = /^[\/0-9]{4,20}?$/i
    const nameRegex = /^(?=.*[A-Za-z])[\u00C0-\u1FFF\u2C00-\uD7FF\w\-\s]+$/;

    this.updateUserForm = this.fb.group({
      'firstname': ['', Validators.compose([Validators.required, Validators.pattern(nameRegex),
          Validators.minLength(2), Validators.maxLength(50)])],
      'lastname': ['', Validators.compose([Validators.required, Validators.pattern(nameRegex),
          Validators.minLength(2), Validators.maxLength(50)])],
      'phone': ['', Validators.compose([Validators.pattern(phoneRegex),
          Validators.maxLength(20)])],
      'email': ['', Validators.compose([Validators.required, Validators.email])]
    });
  }

  resetPassword(resetData) {
	this.editResetPassword = false;
    this.ga.emitEvent('My Profile', 'Reset Password', 'Click');
    this.loginService.resetPassword(resetData)
      .subscribe(() => {
        this.notifications.success(this.translate.instant('common.success'), this.translate.instant('profile.passSuccess'));
        this.reset.oldPassword = null;
  	  	this.reset.newPassword = null;
  	  	this.reset.confirmPassword = null;
  	  	this.resetPwd.value.oldPassword = null;
  	  	this.resetPwd.value.newPassword = null;
  	  	this.resetPwd.value.confirmPassword = null;
      }, () => {
    	  this.reset.oldPassword = null;
    	  this.reset.newPassword = null;
    	  this.reset.confirmPassword = null;
    	  this.resetPwd.value.oldPassword = null;
    	  this.resetPwd.value.newPassword = null;
    	  this.resetPwd.value.confirmPassword = null;
        this.notifications.error(this.translate.instant('common.error'), this.translate.instant('profile.passFail'));
      });
  }

  customValidator(group: FormGroup) {
    const newPassword = group.controls.newPassword.value;
    const confirmPassword = group.controls.confirmPassword.value;
    return newPassword === confirmPassword ? null : {notEqual: true};
  }

  updateAccount(user) {
	this.editProfile = false;
    this.ga.emitEvent('My Profile', 'Update', 'Click');
    this.loginService.updateAccount(user)
      .subscribe((res) => {
        this.currentUser = res;
        this.notifications.success(this.translate.instant('common.success'), this.translate.instant('profile.profileSuccess'));
      }, () => {
    	this.changedUser.firstName = this.currentUser.firstName;
    	this.changedUser.lastName = this.currentUser.lastName;
    	this.updateUserForm.value.firstname = this.currentUser.firstName;
    	this.updateUserForm.value.lastname = this.currentUser.lastName;
        this.notifications.error(this.translate.instant('common.error'), this.translate.instant('profile.profileFail'));
      });
  }
  
  editProfileAction() {
	 this.editProfile = true;
	 this.ga.emitEvent('My Profile', 'Edit Profile', 'Click');
  }
  
  cancelEditProfileAction() {
	  this.editProfile = false;
	  this.ga.emitEvent('My Profile', 'Cancel Edit Profile', 'Click');
	  this.changedUser.firstName = this.currentUser.firstName;
	  this.changedUser.lastName = this.currentUser.lastName;
	  this.changedUser.phone = this.currentUser.phone;
	  this.updateUserForm.value.firstname = this.currentUser.firstName;
	  this.updateUserForm.value.lastname = this.currentUser.lastName;
	  this.updateUserForm.value.phone = this.currentUser.phone;
  }
  
  editResetPasswordAction() {
	 this.editResetPassword = true;
	 this.ga.emitEvent('My Profile', 'Edit Reset Password', 'Click');
  }
  
  cancelEditResetPasswordAction() {
	  this.editResetPassword = false;
	  this.ga.emitEvent('My Profile', 'Cancel Edit Reset Password', 'Click');
	  this.reset.oldPassword = null;
	  this.reset.newPassword = null;
	  this.reset.confirmPassword = null;
	  this.resetPwd.value.oldPassword = null;
	  this.resetPwd.value.newPassword = null;
	  this.resetPwd.value.confirmPassword = null;
  }
}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/profile/profile.component.ts